import React, { Component } from "react";
import { Icon, Button, Image, Grid } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import TractorItem from "../TractorItem";
import AttachmentItem from "../AttachmentItem/index";

class PanelHeader extends Component {
  //state = { open: false, showAll: false };

  constructor(props) {
    super(props);
    this.state = { open: false, showAll: false };
    // this.key = this.props.title.toLowerCase().replace(" ", "");
    this.key = this.props.label.toLowerCase().replace(/\s/g, "");
    this.type = this.props.type.toLowerCase().replace(" ", "");
    //window.addEventListener("hashchange", this.handleHashChange, false);
  }

  toggle = () => {
    this.setState({ open: !this.state.open });

    if (!this.state.open) {
      const params = new URLSearchParams(document.location.search);
      params.set("panel", this.key);

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        params.toString() +
        window.location.hash;
      //alert(newurl);
      window.history.replaceState({ path: newurl }, "", newurl);
      if (window.localStorage) {
        localStorage.setItem("activePanel", this.key);
      }
    } else {
      this.setState({ open: false });
    }
  };

  componentDidMount() {
    if (this.props.state === true) this.toggle();
  }

  render() {
    const open = this.state.open;
    let basicPanels = this.props.basicPanels || [];
    let premiumPanels = this.props.premiumPanels || [];
    let cta = this.props.cta || [];

    return (
      <div className={"accordion panel-header " + this.props.className}>
        <div
          className={"title " + (open ? "active" : null)}
          style={{ backgroundColor: open ? this.props.accent : "#E5E6E6" }}
        >
          <div
            onClick={this.toggle}
            className="thumb"
            style={{ flex: open ? 0 : 1 }}
          />
          <div
            onClick={this.toggle}
            className="desc"
            style={{ borderLeftColor: "#FDDA01" }}
          >
            <span className="text">{this.props.label}</span>
          </div>
          <div onClick={this.toggle} className="arrow">
            <div
              className="icon"
              style={{ transform: open ? "rotate(90deg)" : "inherit" }}
            >
              <Icon name="chevron right" />
            </div>
          </div>
        </div>

        {open && (
          <div>
            <div className="content active">
              <Grid columns={2} padded stackable>
                <Grid.Row>
                  <Grid.Column width={6} className="summary">
                    <h2>{this.props.title}</h2>
                    <p>{this.props.desc}</p>
                    {cta.map((item, index) => {
                            return (
                              <div><a href={item.ctaURL}>{item.ctaTitle}&nbsp;›</a></div>
                            );
                          })}
                  </Grid.Column>
                  <Grid.Column width={10}>
                    {this.props.vidID.length > 0 ? (
                      <div className="embed-responsive embed-responsive-16by9">
                        <iframe
                          className="embed-responsive-item"
                          src={
                            "https://www.youtube.com/embed/" + this.props.vidID
                          }
                          title="vid"
                        />
                      </div>
                    ) : (
                      <Image src={this.props.imgURL} />
                    )}
                  </Grid.Column>
                </Grid.Row>
                {basicPanels == false ? (
                  ""
                ) : (
                  <Grid.Row className="package-title">
                    <h2>{basicPanels["packageTitle"] ? basicPanels["packageTitle"] : "Basic Package"}</h2>
                  </Grid.Row>
                )}
                <Grid.Row className="package-content">
                  {basicPanels == false ? (
                    ""
                  ) : (
                    <TractorItem
                      tractor={basicPanels["tractor"]["tractorTitle"]} //"1023E Sub-Compact Utility Tractor"
                      img={basicPanels["tractor"]["tractorImg"]} //"/img/1023e_tractor_r4c0010363.jpg"
                      link={basicPanels["tractor"]["tractorLink"]}
                      series={basicPanels["tractor"]["tractorSeries"]}
                      packageBtn={basicPanels["buyThisPackageText"]}
                    />
                  )}
                  {basicPanels == false ? (
                    ""
                  ) : (
                    <Grid.Column width={10}>
                      <Grid columns={2} padded stackable>
                        <Grid.Row className="m0 p0">
                          {basicPanels["attachments"].map((item, index) => {
                            return (
                              <AttachmentItem
                                title={item.title}
                                id={item.partNum}
                                part={item.partNumText}
                                desc="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus mi ipsum, dapibus sit amet velit non, vulputate ullamcorper nunc."
                                img={item.imgURL}
                              />
                            );
                          })}
                          {/* {this.props.children({ basicPanels })} */}
                        </Grid.Row>
                      </Grid>
                    </Grid.Column>
                  )}
                </Grid.Row>
                {premiumPanels == false ? (
                  ""
                ) : (
                  <Grid.Row className="package-title">
                    <h2>{premiumPanels["packageTitle"] ? premiumPanels["packageTitle"] : "Premium Package"}</h2>
                  </Grid.Row>
                )}
                <Grid.Row className="package-content">
                  {premiumPanels == false ? (
                    ""
                  ) : (
                    <TractorItem
                      tractor={premiumPanels["tractor"]["tractorTitle"]} //"1025R Sub-Compact Utility Tractor"
                      img={premiumPanels["tractor"]["tractorImg"]} //"/img/1025r_tractor_r4g027906.jpg"
                      link={premiumPanels["tractor"]["tractorLink"]}
                      series={premiumPanels["tractor"]["tractorSeries"]}
                      packageBtn={premiumPanels["buyThisPackageText"]}
                    />
                  )}
                  {premiumPanels == false ? (
                    ""
                  ) : (
                    <Grid.Column width={10}>
                      <Grid columns={2} padded stackable>
                        <Grid.Row className="m0 p0">
                          {premiumPanels["attachments"].map((item, index) => {
                            return (
                              <AttachmentItem
                                title={item.title}
                                id={item.partNum}
                                part={item.partNumText}
                                desc={item.desc}
                                img={item.imgURL}
                              />
                            );
                          })}
                          {/* {this.props.children({premiumPanels})} */}
                        </Grid.Row>
                      </Grid>
                    </Grid.Column>
                  )}
                </Grid.Row>
              </Grid>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(PanelHeader);

/*
 Fix attachment images, if there is no image hide the image element

*/


// WEBPACK FOOTER //
// ./src/components/PanelHeader/index.js